// File: src/components/ui/DateRangePills.jsx
import React from 'react';
import './DateRangePills.css';

const DEFAULT_OPTIONS = [
  { label: '24h', value: '1' },
  { label: '7d', value: '7' },
  { label: '30d', value: '30' },
  { label: '90d', value: '90' },
  { label: '180d', value: '180' },
];

export default function DateRangePills({ 
  value, 
  onChange, 
  options = DEFAULT_OPTIONS,
  size = 'medium' // 'small', 'medium', 'large'
}) {
  return (
    <div className={`date-range-pills date-range-pills--${size}`}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`date-pill ${value === option.value ? 'date-pill--active' : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}